/** 공개 사이트 페이지 본문 문구 — ko/landingPages.ts 와 같은 키(정본은 ko). */
const landingPages = {
  news: {
    eyebrow: "ព័ត៌មានសារព័ត៌មាន",
    title: "ព័ត៌មានសារព័ត៌មាន",
    count: "សរុប {{n}} អត្ថបទ",
    listLabel: "បញ្ជីអត្ថបទ",
    readMore: "អានអត្ថបទ",
    openLabel: "{{title}} — មើលអត្ថបទ",
    back: "ត្រឡប់ទៅបញ្ជី",
    original: "មើលអត្ថបទដើម",
    empty: "មិនទាន់មានអត្ថបទនៅឡើយ។",
    imageUnavailable: "មិនអាចផ្ទុករូបភាពបានទេ",
    translatedFrom: {
      ja: "អត្ថបទនេះត្រូវបានបកប្រែជាភាសាកូរ៉េពីអត្ថបទដើមជាភាសាជប៉ុន។",
    },
    related: {
      title: "មើលបន្ថែម",
      platform: {
        alt: "ក្រឡាឈ្មោះកម្មវិធី DroneSquare អណ្ដែតលើបន្ទះរូបភាព Ortho គំនូរ និងស្រទាប់ 3D",
        kicker: "វេទិកាសេវាកម្ម",
        title: "វេទិកាគ្រប់គ្រងហេដ្ឋារចនាសម្ព័ន្ធដោយ Drone",
        text: "ត្រួតពិនិត្យ និងកត់ត្រាការដ្ឋានដែលថតដោយ Drone ជា 2D·3D។",
      },
      releases: {
        alt: "កណ្ដឹងជូនដំណឹងពណ៌មាសកំពុងរោទ៍ ដែលមានសញ្ញាលេខ 3 និងកាតជូនដំណឹងកម្មវិធី DroneSquare នៅខាងក្រោម",
        kicker: "ព័ត៌មានថ្មីៗ",
        title: "DroneSquare កាន់តែថ្មី",
        text: "ស្វែងយល់មុខងារថ្មីៗ ជាមួយវីដេអូបង្ហាញ។",
      },
    },
  },
  plan: {
    title: "គម្រោងសេវាកម្ម DroneSquare",
    lead: "តាមដានការដ្ឋាន និងសម្រេចការថែទាំល្អបំផុត<br/>ជាមួយការវិភាគទិន្នន័យត្រឹមត្រូវរបស់ DroneSquare។",
    plansLabel: "គម្រោង",
    standard: {
      name: "Standard Plan",
      description: "សម្រាប់វិភាគ និងគ្រប់គ្រង<br/><b>ការដ្ឋានខ្នាតតូច</b>",
      features: [
        "ការជាវប្រចាំខែ",
        "រូបភាព Drone 3000 សន្លឹក / ការរៀបចំគម្រោង Drone",
        "ដំណើរការទិន្នន័យ 2 ដងក្នុងមួយខែ",
      ],
    },
    advanced: {
      name: "Advanced Plan",
      description: "សម្រាប់វិភាគ និងគ្រប់គ្រង<br/><b>ការដ្ឋានខ្នាតធំ</b>",
      features: [
        "ការជាវប្រចាំឆ្នាំ\nដោយពិភាក្សាជម្រើសប្រើប្រាស់ផ្សេងៗដោយបត់បែន",
        "រូបភាព Drone 3000+ សន្លឹក / ការរៀបចំគម្រោង Drone",
      ],
    },
    ask: "សាកសួរ",
    compare: {
      title: "ប្រៀបធៀបភ្លាមៗ",
      item: "ធាតុ",
      rows: [
        {
          label: "គោលដៅ",
          standard: "ការដ្ឋានខ្នាតតូច",
          advanced: "ការដ្ឋានខ្នាតធំ",
        },
        {
          label: "របៀបជាវ",
          standard: "ប្រចាំខែ",
          advanced: "ប្រចាំឆ្នាំ",
        },
        {
          label: "ការរៀបចំគម្រោង Drone",
          standard: "រូបភាព Drone 3000 សន្លឹក",
          advanced: "រូបភាព Drone 3000+ សន្លឹក",
        },
        {
          label: "ដំណើរការទិន្នន័យ",
          standard: "2 ដងក្នុងមួយខែ",
          advanced: "ពិភាក្សាដោយបត់បែន",
        },
      ],
    },
    related: {
      title: "មើលបន្ថែមជាមួយគម្រោង",
      platform: {
        alt: "ក្រឡាឈ្មោះកម្មវិធី DroneSquare អណ្ដែតលើបន្ទះរូបភាព Ortho គំនូរ និងស្រទាប់ 3D",
        kicker: "វេទិកា",
        title: "វេទិកាគ្រប់គ្រងហេដ្ឋារចនាសម្ព័ន្ធដោយ Drone",
        text: "2D·3D·4D ការវាស់វែង និងផ្នែកកាត់ ការត្រួតទិន្នន័យទាំងអស់ និងកំណត់ត្រាការដ្ឋាន នៅលើអេក្រង់តែមួយ។",
      },
      survey: {
        alt: "Drone ហោះលើទឹក",
        kicker: "ការវាស់វែងដោយ Drone និងដំណើរការទិន្នន័យលំហ",
        title: "ទុកឱ្យយើងធ្វើចាប់ពីការថតដល់វេទិកា",
        text: "អ្នកជំនាញប្រតិបត្តិការ Drone ធ្វើដោយផ្ទាល់ ចាប់ពីការអនុញ្ញាតហោះហើរ ដល់វេទិកា។",
      },
    },
    closing: {
      eyebrow: "DroneSquare សាកសួរ 1:1",
      title: "យើងនឹងជួយកំណត់គម្រោង<br/>ដែលសមនឹងការដ្ឋានរបស់អ្នក",
    },
  },
  inquiry: {
    eyebrow: "សាកសួរ 1:1",
    title: "DroneSquare សាកសួរ 1:1",
    copy: "ជាមួយ DroneSquare<br/><em>ការគ្រប់គ្រង និងវិភាគទ្រព្យហេដ្ឋារចនាសម្ព័ន្ធឆ្លាតវៃ</em>",
    photoAlt: "Drone ថតរូបហោះលើការដ្ឋាន",
    chatTitle: "DroneSquare ពិគ្រោះ 1:1",
    chatFallback: "កម្មវិធីរុករកនេះមិនអាចបង្ហាញផ្ទាំងពិគ្រោះបានទេ។",
    chatLoading: "កំពុងបើកផ្ទាំងពិគ្រោះ",
    chatFailedTitle: "មិនអាចបើកផ្ទាំងពិគ្រោះបានទេ",
    chatFailedText: "សូមព្យាយាមម្ដងទៀតបន្តិចក្រោយ ឬទូរស័ព្ទមកលេខចម្បងរបស់យើង។",
    chatRetry: "ព្យាយាមម្ដងទៀត",
    chatCall: "ទូរស័ព្ទ {{tel}}",
    chatOpen: "សួរតាមការជជែក",
    chatClose: "បិទ",
    moreTitle: "សូមមើលមុនពេលសាកសួរ",
    manual: {
      alt: "ក្រឡាឈ្មោះកម្មវិធី DroneSquare នៅក្បែរកាតណែនាំដែលមានជំហាន 1·2·3 និងព្រួញកណ្ដុរ",
      kicker: "សៀវភៅណែនាំ",
      title: "របៀបប្រើតាមអេក្រង់",
      text: "ធ្វើតាមចាប់ពីការបង្កើតគម្រោង ដល់ការវាស់ 3D។",
    },
    plan: {
      alt: "ក្រឡាឈ្មោះកម្មវិធី DroneSquare នៅក្បែរកាតគម្រោង Standard និង Advanced ពីរ",
      kicker: "គម្រោងប្រើប្រាស់",
      title: "Standard · Advanced",
      text: "ប្រៀបធៀបគម្រោងដែលសមនឹងទំហំការដ្ឋានរបស់អ្នក។",
    },
    survey: {
      alt: "Drone ហោះតាមផ្លូវចំណុចលើបន្ទះការដ្ឋាន នៅក្បែរកាតលទ្ធផលផែនទីសណ្ឋានដី",
      kicker: "សេវាវាស់វែងដោយ Drone",
      title: "ចាប់ពីការថតដល់វេទិកា",
      text: "អ្នកជំនាញប្រតិបត្តិការ Drone ថត និងដំណើរការដោយផ្ទាល់។",
    },
  },
  survey: {
    eyebrow: "ការវាស់វែងដោយ Drone និងដំណើរការទិន្នន័យលំហ",
    title: "ដំណោះស្រាយ Drone end-to-end<br/>ដែលបង្កើតដោយអ្នកជំនាញ",
    description:
      "អ្នកជំនាញប្រតិបត្តិការ Drone អនុវត្តតាមតម្រូវការរបស់អតិថិជន ចាប់ពីការថតតំបន់គោលដៅ ដល់ការធ្វើផែនទីភាពជាក់លាក់ខ្ពស់ យ៉ាងរហ័ស និងត្រឹមត្រូវ។",
    heroAlt: "Drone ថតរូបពណ៌សហោះលើព្រៃ",
    ask: "សាកសួរ",
    process: {
      eyebrow: "ដំណើរការ",
      title: "ចាប់ពីការអនុញ្ញាតហោះហើរ<br/>ដល់វេទិកា",
    },
    results: {
      eyebrow: "លទ្ធផល",
      title: "លទ្ធផលពីការថតតែម្ដង",
      lead: "លទ្ធផលទាំងអស់ត្រូវបានផ្ទុកឡើងទៅវេទិកា DroneSquare ដើម្បីពិនិត្យភ្លាមៗលើអេក្រង់ 2D·3D។",
      tabsLabel: "ប្រភេទលទ្ធផល",
      tabs: [
        {
          name: "រូបភាព Ortho",
          note: "ផែនទីគុណភាពខ្ពស់ដែលកែការខូចទ្រង់ទ្រាយ",
          alt: "លទ្ធផល៖ រូបភាព Ortho។ ការដ្ឋានការងារដីមើលពីលើទិសឦសាន។",
        },
        {
          name: "DSM",
          note: "ម៉ូដែលកម្ពស់ផ្ទៃដី",
          alt: "លទ្ធផល៖ DSM ពីទស្សនៈដដែល។ កន្លែងទាបពណ៌ខៀវ កន្លែងខ្ពស់ពណ៌ក្រហម។",
        },
        {
          name: "Point Cloud",
          note: "ទិន្នន័យចំណុចពីការតម្រឹមរូបថត",
          alt: "លទ្ធផល៖ Point Cloud ពីទស្សនៈដដែល។ ការដ្ឋានបង្ហាញជា 3D ដោយចំណុចពណ៌ក្រាស់។",
        },
        {
          name: "ម៉ូដែល 3D",
          note: "ម៉ូដែល 3D វាយនភាពរូបថតពិត",
          alt: "លទ្ធផល៖ ម៉ូដែល 3D ពីទស្សនៈដដែល។ ជម្រាលកាត់ និងផ្លូវចូលបង្ហាញជា 3D។",
        },
        {
          name: "ផែនទីសណ្ឋានដីសាមញ្ញ",
          note: "ខ្សែវណ្ឌវង្កចន្លោះ 1 ម៉ែត្រ",
          alt: "លទ្ធផល៖ ផែនទីសណ្ឋានដីសាមញ្ញពីទស្សនៈដដែល ជាមួយខ្សែវណ្ឌវង្ក 1 ម៉ែត្រ និងខ្សែសន្ទស្សន៍ 5 ម៉ែត្រ។",
        },
      ],
    },
    closing: {
      eyebrow: "វេទិកា",
      title: "វេទិកាគ្រប់គ្រង<br/>ហេដ្ឋារចនាសម្ព័ន្ធដោយ Drone",
      more: "មើលលម្អិត",
      ask: "សាកសួរ",
    },
  },
  accurate: {
    eyebrow: "វេទិកា",
    title: "វេទិកាគ្រប់គ្រង<br/>ហេដ្ឋារចនាសម្ព័ន្ធដោយ Drone",
    description:
      "ប្រើ DroneSquare ដើម្បីបំប្លែងទិន្នន័យលំហទៅជាព័ត៌មានអាជីវកម្មដែលមានតម្លៃ។",
    start: "ចាប់ផ្ដើម",
    ask: "សាកសួរ",
    heroVideoLabel:
      "អេក្រង់ត្រួតពិនិត្យ 3D ពេញរបស់ DroneSquare៖ ផ្ទាំងបញ្ហា និងរបារឧបករណ៍ខាងឆ្វេង និងវីដេអូបង្វិលយឺតៗមើលម៉ូដែល 3D នៃការដ្ឋានជីកដីពីទិសទ្រេត ដែលបង្កើតពីរូបថត Drone។",
    index: {
      title: "ទិន្នន័យការដ្ឋានទាំងអស់<br/>នៅលើអេក្រង់តែមួយ",
      label: "មុខងារវេទិកា",
      items: [
        {
          title: "2D · 3D · 4D",
          text: "ផ្លាស់ប្ដូររវាងរូបភាព Ortho និងម៉ូដែល 3D ហើយបែងចែកអេក្រង់ដើម្បីប្រៀបធៀបតាមថ្ងៃថត។",
        },
        {
          title: "ការវាស់ · ផ្នែកកាត់ · ការងារដី",
          text: "គូរខ្សែដើម្បីមើលផ្នែកកាត់ដី និងរចនាសម្ព័ន្ធ ហើយវាស់ការងារដី ប្រវែង ផ្ទៃ និងមាឌ។",
        },
        {
          title: "ទិន្នន័យទាំងអស់",
          text: "ត្រួត និងកាត់ DXF·GIS·BIM·Point Cloud·វ៉ិចទ័រ នៅក្នុងអេក្រង់ 3D តែមួយ។",
        },
        {
          title: "កំណត់ត្រាការដ្ឋាន · ការតាមដាន",
          text: "ទុកបញ្ហា រូបថត វីដេអូ និង 360° តាមទីតាំងនីមួយៗ ហើយពិនិត្យហានិភ័យផ្លូវឧបករណ៍។",
        },
      ],
    },
    site: {
      eyebrow: "កំណត់ត្រាការដ្ឋាន · ការតាមដាន",
      title: "កំណត់ត្រាការដ្ឋាន និងហានិភ័យឧបករណ៍<br/>នៅលើផែនទីតែមួយ",
      lead: "ទុកកំណត់ត្រាបញ្ហា រូបថត វីដេអូ និង 360° តាមទីតាំងនីមួយៗ<brd/> ហើយដំណើរការផ្លូវឧបករណ៍ជាមុន ដើម្បីរកកន្លែងដែលកាំការងារត្រួតគ្នា។",
    },
    more: {
      title: "ស្វែងយល់បន្ថែម",
      survey: {
        alt: "Drone ថតរូបហោះលើទឹក",
        kicker: "ការវាស់វែងដោយ Drone និងដំណើរការទិន្នន័យលំហ",
        title: "ដំណោះស្រាយ Drone end-to-end ដែលបង្កើតដោយអ្នកជំនាញ",
        text: "ចាប់ពីការអនុញ្ញាតហោះហើរ ដល់វេទិកា ធ្វើដោយអ្នកជំនាញប្រតិបត្តិការ Drone ផ្ទាល់។",
      },
      plan: {
        alt: "កាតគម្រោងពីរ Standard និង Advanced នៅជាប់គ្នា",
        kicker: "គម្រោងប្រើប្រាស់",
        title: "គម្រោងសេវាកម្ម DroneSquare",
        text: "ប្រៀបធៀបគម្រោង Standard និង Advanced សម្រាប់ទំហំការដ្ឋានរបស់អ្នក។",
      },
    },
    closing: {
      eyebrow: "ជំហានបន្ទាប់",
      title: "ការវាស់វែងដោយ Drone និង<br/>ដំណើរការទិន្នន័យលំហ",
      more: "មើលលម្អិត",
      ask: "សាកសួរ",
    },
  },
  landing: {
    hero: {
      title: "វេទិកាគ្រប់គ្រង ហេដ្ឋារចនាសម្ព័ន្ធដោយ Drone",
      ask: "សាកសួរ",
      start: "ចាប់ផ្ដើម",
      sceneLabel:
        "Drone ហោះលើការដ្ឋានជីកដី ហើយថតរូប រូបថតត្រូវបានផ្គុំជារូបភាព Ortho មួយ បន្ទាប់មកកន្លែងដដែលលេចឡើងជាម៉ូដែល 3D",
    },
    service: {
      eyebrow: "ការវាស់វែងដោយ Drone និងដំណើរការទិន្នន័យលំហ",
      title: "ដំណោះស្រាយ Drone end-to-end<br/>ដែលបង្កើតដោយអ្នកជំនាញ",
      lead: "អ្នកជំនាញប្រតិបត្តិការ Drone អនុវត្តតាមតម្រូវការរបស់អតិថិជន<brd/> ចាប់ពីការថតតំបន់គោលដៅ ដល់ការធ្វើផែនទីភាពជាក់លាក់ខ្ពស់ យ៉ាងរហ័ស និងត្រឹមត្រូវ។",
    },
    closing: {
      eyebrow: "DroneSquare សាកសួរ 1:1",
      title:
        "ការគ្រប់គ្រង និងវិភាគទ្រព្យហេដ្ឋារចនាសម្ព័ន្ធឆ្លាតវៃជាមួយ DroneSquare",
    },
  },
  status: {
    home: "ទៅទំព័រដើម",
    notFound: {
      title: "រកមិនឃើញទំព័រ",
      lead: "អាសយដ្ឋានអាចបានផ្លាស់ប្ដូរ ឬទំព័រនេះលែងមានហើយ។",
    },
    prepare: {
      title: "ទំព័រនេះកំពុងរៀបចំ",
      lead: "យើងនឹងរៀបចំវាឱ្យរួចរាល់ឆាប់ៗនេះ។",
    },
  },
  meta: {
    siteName: "DroneSquare",
    imageAlt:
      "និមិត្តសញ្ញា DroneSquare នៅខាងឆ្វេង DroneSquare និង «វេទិកាគ្រប់គ្រងហេដ្ឋារចនាសម្ព័ន្ធដោយ Drone» នៅខាងក្រោម លើរូបភាព Ortho នៃការដ្ឋានសំណង់ដែលផ្គុំពីរូបថត Drone",
    landing: {
      title: "DroneSquare | វេទិកាគ្រប់គ្រងហេដ្ឋារចនាសម្ព័ន្ធដោយ Drone",
      description:
        "វេទិកាគ្រប់គ្រងហេដ្ឋារចនាសម្ព័ន្ធ សម្រាប់មើល ត្រួតពិនិត្យ និងគ្រប់គ្រងការដ្ឋានដែលថតដោយ Drone ជា 2D និង 3D។",
    },
    accurate: {
      title: "វេទិកា | DroneSquare",
      description:
        "ប្រើ DroneSquare ដើម្បីបំប្លែងទិន្នន័យលំហទៅជាព័ត៌មានអាជីវកម្មដែលមានតម្លៃ។",
    },
    survey: {
      title: "ការស្ទង់ដោយ Drone និងដំណើរការទិន្នន័យលំហ | DroneSquare",
      description:
        "អ្នកជំនាញប្រតិបត្តិការ Drone ធ្វើការងារផ្ទាល់ ចាប់ពីការអនុញ្ញាតហោះហើររហូតដល់រូបភាព Ortho, DSM, ម៉ូដែល 3D និងផែនទីសណ្ឋានដីសាមញ្ញ។",
    },
    plan: {
      title: "គម្រោងប្រើប្រាស់ | DroneSquare",
      description:
        "ប្រៀបធៀបគម្រោង Standard និង Advanced ដែលសមនឹងទំហំការដ្ឋានរបស់អ្នក។",
    },
    inquiry: {
      title: "សាកសួរ 1:1 | DroneSquare",
      description:
        "យើងទទួលការសាកសួរអំពីការប្រើប្រាស់ DroneSquare តាមរយៈការជជែក និងទូរសព្ទ។",
    },
    news: {
      title: "ព័ត៌មានសារព័ត៌មាន | DroneSquare",
      description: "អត្ថបទព័ត៌មានអំពី DroneSquare។",
    },
    manual: {
      title: "សៀវភៅណែនាំ | DroneSquare",
      description: "រៀនប្រើអេក្រង់នីមួយៗរបស់ DroneSquare ដោយធ្វើតាមវីដេអូ។",
    },
    releases: {
      title: "ព័ត៌មានថ្មីៗ | DroneSquare",
      description: "ជួបបច្ចេកវិទ្យាការដ្ឋានទំនើបបំផុតមុនគេនៅ DroneSquare។",
    },
    privacy: {
      title: "Privacy Policy | DroneSquare",
      description:
        "What personal information DroneSquare collects, why, how long it is kept, who processes it, and your rights.",
    },
    login: {
      title: "ចូលប្រព័ន្ធ | DroneSquare",
      description: "ចូលប្រព័ន្ធដោយគណនី DroneSquare របស់អ្នក។",
    },
    signup: {
      title: "ចុះឈ្មោះ | DroneSquare",
      description: "បង្កើតគណនី DroneSquare។",
    },
    changepassword: {
      title: "ផ្លាស់ប្ដូរពាក្យសម្ងាត់ | DroneSquare",
      description:
        "ទទួលលេខកូដផ្ទៀងផ្ទាត់តាមអ៊ីមែលដែលបានចុះឈ្មោះ ហើយផ្លាស់ប្ដូរពាក្យសម្ងាត់។",
    },
    notFound: {
      title: "រកមិនឃើញទំព័រ | DroneSquare",
      description: "អាសយដ្ឋានអាចបានផ្លាស់ប្ដូរ ឬទំព័រនេះលែងមានហើយ។",
    },
    prepare: {
      title: "កំពុងរៀបចំ | DroneSquare",
      description: "យើងនឹងរៀបចំវាឱ្យរួចរាល់ឆាប់ៗនេះ។",
    },
    article: {
      title: "{{title}} | DroneSquare ព័ត៌មាន",
    },
  },
} as const;

export default landingPages;
